<link rel="stylesheet" media="print" [href]="printCssHref">
<main class="page-main">
  <div class="container layout layout--docs">
    <div class="layout__row">
      <div class="layout__sidecol d-none d-lg-block">
        <div class="details-nav">
          <nav class="details-nav__inner">
            <ul class="list-unstyled" id="docs-nav">
              <li class="is-active">
                <a href="everything.docs-broker-appointment-letter.html">Broker Appointment Letter</a>
              </li>
              <li>
                <a href="everything.docs-debit-order-authority.html">Debit Order Authority</a>
              </li>
              <li>
                <a href="everything.docs-terms-and-conditions.html">Terms and Conditions</a>
              </li>
              <li>
                <a href="everything.docs-fee-agreement.html">Fee Agreement</a>
              </li>
              <li>
                <a href="everything.policy-wording.html">Policy Wording</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="layout__bodycol" id="search-body">
        <header class="docs-header">
          <div class="docs-header__company">
            <div class="docs-header__company-thumb">
              <img src="assets/insurer/santam.svg" class="img-fluid" />
            </div>
            <div class="docs-header__company-rating">
              <div class="stars-compact">
                <div class="stars-compact__star">
                  <svg class="icon"><use xlink:href="#star"></use></svg>
                </div>
                <div class="stars-compact__num">5</div>
              </div>
            </div>
            <div class="docs-header__company-name">
              <h6>Cost Conscious</h6>
            </div>
          </div>

          <div class="docs-header__title">
            <h1 class="font-serif">Policy Statement</h1>
          </div>

          <div class="docs-header__grid">
            <div class="docs-header__grid-col docs-header__grid-col--left">
              <div class="docs-header__grid-cell">
                <p>
                  <strong>
                    Madikwe Futures Company NPC<br />
                    PO Box 775<br />
                    Groenkloof<br />
                    0027
                  </strong>
                </p>
              </div>
            </div>
            <div class="docs-header__grid-col docs-header__grid-col--right">
              <div class="docs-header__grid-cell">
                <p>
                  <small
                  ><strong>
                    01/05/2021 – 31/05/2021<br />
                    Policy No. SATIB137295<br />
                    Personal.Insure<br />
                    Cost Conscious
                  </strong></small
                  >
                </p>
              </div>
            </div>
          </div>
        </header>

        <section class="docs-content docs-content--wording docs-content--first" id="docs-overview">
          <div class="table-responsive">
            <table class="table table--financial">
              <thead>
              <tr>
                <th>Date</th>
                <th class="cell-xxs">Invoice No.</th>
                <th class="cell-xs">Description</th>
                <th class="cell-fig">Transaction Amount</th>
                <th class="cell-fig">Payment</th>
                <th class="cell-fig">Amount (Incl. VAT)</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="cell-info" colspan="5">Opening Balance</td>
                <td class="cell-fig">R 0.00</td>
              </tr>
              <tr>
                <td>06/01/2019</td>
                <td class="cell-xxs">1034291</td>
                <td class="cell-xs">Premium (monthly)</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 0.00</td>
              </tr>
              <tr>
                <td>06/01/2019</td>
                <td class="cell-xxs">1034291</td>
                <td class="cell-xs">Premium (pro rata)</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 0.00</td>
              </tr>
              <tr>
                <td>06/01/2019</td>
                <td class="cell-xxs">1034291</td>
                <td class="cell-xs">Premium (pro rata refund)</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 0.00</td>
              </tr>
              <tr>
                <td>06/01/2019</td>
                <td class="cell-xxs">1034291</td>
                <td class="cell-xs">Refund (cancellation)</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 0.00</td>
              </tr>
              <tr>
                <td>06/01/2019</td>
                <td class="cell-xxs">1034291</td>
                <td class="cell-xs">Refund (pause)</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 0.00</td>
              </tr>
              <tr>
                <td>06/01/2019</td>
                <td class="cell-xxs">1034291</td>
                <td class="cell-xs">Claim (excess payment)</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 0.00</td>
              </tr>
              <tr>
                <td>06/01/2019</td>
                <td class="cell-xxs">1034291</td>
                <td class="cell-xs">Claim (settlement)</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 9 999.99</td>
                <td class="cell-fig">R 0.00</td>
              </tr>
              <tr>
                <td><strong>Total</strong></td>
                <td class="cell-xxs">&nbsp;</td>
                <td class="cell-xs">&nbsp;</td>
                <td class="cell-fig"><strong>R 9 999.99</strong></td>
                <td class="cell-fig"><strong>R 9 999.99</strong></td>
                <td class="cell-fig"><strong>R 0.0</strong></td>
              </tr>
              <tr class="row-total">
                <td><strong>Total Due</strong></td>
                <td class="cell-xxs">&nbsp;</td>
                <td class="cell-xs">&nbsp;</td>
                <td class="cell-fig">&nbsp;</td>
                <td class="cell-fig">&nbsp;</td>
                <td class="cell-fig"><strong>R 0.0</strong></td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="note mt-20">
            <div class="note__icon">
              <svg class="icon"><use xlink:href="#info-small"></use></svg>
            </div>
            <div class="note__content">
              <h6>Important</h6>
              <p>
                The insurance amendment act regulates payment of premiums. Insurers are entitled to invoke a "no premium no cover" condition. To avoid this possibility please pay the
                premiums indicated immediately.
              </p>
            </div>
          </div>

          <div class="docs-content__overdue row row--xxs mt-60">
            <div class="col">
              <div class="docs-content__overdue-item is-active">
                <strong>60 Day+</strong>
                <span>R 0.00</span>
              </div>
            </div>
            <div class="col">
              <div class="docs-content__overdue-item">
                <strong>60 Day</strong>
                <span>R 0.00</span>
              </div>
            </div>
            <div class="col">
              <div class="docs-content__overdue-item">
                <strong>30 Day</strong>
                <span>R 0.00</span>
              </div>
            </div>
            <div class="col">
              <div class="docs-content__overdue-item">
                <strong>Current</strong>
                <span>R 0.00</span>
              </div>
            </div>
            <div class="col">
              <div class="docs-content__overdue-item">
                <strong>Total</strong>
                <span>R 0.00</span>
              </div>
            </div>
          </div>

          <div class="docs-content__details row row--xs mt-20">
            <div class="col-sm-6">
              <div class="docs-content__details-cell">
                <h6>Banking Details</h6>
                <ul class="data data--summary">
                  <li class="data__row">
                    <label class="data__label"> Beneficiary </label>
                    <div class="data__cell">First Equity</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Bank </label>
                    <div class="data__cell">Rand Merchant Bank</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Account No. </label>
                    <div class="data__cell">62851356090</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Branch Code </label>
                    <div class="data__cell">255005</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Deposit Ref </label>
                    <div class="data__cell">SATIB 1 267 247</div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="docs-content__details-cell">
                <h6>Broker Details</h6>
                <ul class="data data--summary">
                  <li class="data__row">
                    <label class="data__label"> Name </label>
                    <div class="data__cell">First Equity Insurance Brokers (Pty) Ltd</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Address </label>
                    <div class="data__cell">First Floor, Block A Hobert Square Office Park, Bryanston, 2191</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Reg No. </label>
                    <div class="data__cell">1996/017839/07</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Vat Reg. No. </label>
                    <div class="data__cell">4730152081</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> FSP No. </label>
                    <div class="data__cell">5227</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</main>

<div class="policy-tray">
  <div class="policy-tray__details">
    <div class="container">
      <a href="#mobile-details" data-toggle="modal" class="button-control">
        <svg class="icon"><use xlink:href="#submenu-alt"></use></svg>
        <strong>More documents</strong>
      </a>
    </div>
  </div>
</div>

<footer class="docs-footer">
  <div class="docs-footer__inner container">
    <img id="logo" src="assets/0/logo.svg" alt="Everything.Insure" />
    <p>
      <strong>Questions?</strong> Contact Everything.Insure at<br />
      &lt;<a href="mailto:support@everything.insure">support&#64;everything.insure</a>&gt; or call <strong>011 510 1300</strong>
    </p>
  </div>
</footer>

<div class="modal fade fade-up modal--fullscreen" id="mobile-details" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <header class="modal-header">
        <div class="container">
          <h6>More documents</h6>
          <a href="#" class="modal-header__close" data-dismiss="modal">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </a>
        </div>
      </header>

      <div class="modal-body">
        <div class="container">
          <div class="details-nav">
            <nav class="details-nav__inner">
              <ul class="list-unstyled" id="docs-nav-mobile">
                <li class="is-active">
                  <a href="everything.docs-broker-appointment-letter.html">Broker Appointment Letter</a>
                </li>
                <li>
                  <a href="everything.docs-debit-order-authority.html">Debit Order Authority</a>
                </li>
                <li>
                  <a href="everything.docs-terms-and-conditions.html">Terms and Conditions</a>
                </li>
                <li>
                  <a href="everything.docs-fee-agreement.html">Fee Agreement</a>
                </li>
                <li>
                  <a href="everything.policy-wording.html">Policy Wording</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
